import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
//import {EventLeftNavComponent} from '../../../events/left-nav/event-left-nav.component';

@Component({
  selector: 'wl-left-nav',
  templateUrl: 'left-nav.component.html',
  styleUrls: ['left-nav.component.css'],
    standalone: false
})
export class LeftNavComponent {
  public constructor() {}
}
